module.exports = "/_next/static/images/ci-abe37e2d6a48ba24e6318ca116013839.svg";